import {
  ArtDBData,
  ArtData,
  ArtGSI1KeyComponents,
  ArtKeyComponents,
} from "./art";
import { TokenData } from "./auth";
import { CartData, CartGSI1KeyComponents, CartKeyComponents } from "./cart";
import {
  LocationData,
  LocationGSI1KeyComponents,
  LocationKeyComponents,
} from "./location";
import { OrderData, OrderGSI1KeyComponents, OrderKeyComponents } from "./order";
import {
  ShipmentData,
  ShipmentGSI1KeyComponents,
  ShipmentKeyComponents,
} from "./shipments";
import {
  DATA_PARTITION_USER_ART_LIKE,
  UserArtLikeData,
  UserArtLikeGSI1KeyComponents,
  UserArtLikeKeyComponents,
} from "./UserArtLike";

export const SITE_DATA_PARTITIONS = {
  ART: "art",
  CART: "cart",
  LOCATION: "location",
  ORDER: "order",
  SHIPMENT: "shipment",
  USER_ART_LIKE: DATA_PARTITION_USER_ART_LIKE,
} as const;
export type SitePartitionName =
  (typeof SITE_DATA_PARTITIONS)[keyof typeof SITE_DATA_PARTITIONS];

export const SITE_TABLE_INDEX = {
  GSI1: "GSI1",
} as const;
export type SiteIndexNames =
  (typeof SITE_TABLE_INDEX)[keyof typeof SITE_TABLE_INDEX];

export type SiteTableKeys = {
  PK: SitePartitionName;
  SK: string;
};
export type SiteTableGSI1Keys = {
  GSI1PK: string;
  GSI1SK: string;
};

export type SiteTableItem =
  | ArtData
  | UserArtLikeData
  | CartData
  | LocationData
  | OrderData
  | ShipmentData;
export type SiteTableKeyComponents =
  | OrderKeyComponents
  | ShipmentKeyComponents
  | ArtKeyComponents
  | UserArtLikeKeyComponents
  | CartKeyComponents
  | LocationKeyComponents;

export type SiteTableGSI1KeyComponents =
  | OrderGSI1KeyComponents
  | ShipmentGSI1KeyComponents
  | ArtGSI1KeyComponents
  | UserArtLikeGSI1KeyComponents
  | CartGSI1KeyComponents
  | LocationGSI1KeyComponents;

export type SiteTableDBItem = SiteTableKeys &
  SiteTableGSI1Keys &
  (OrderData | ArtDBData | CartData | LocationData | ShipmentData);

export type SitePermissionType = {
  isAdmin?: boolean;
  isLoggedIn?: boolean;
  isValidSession?: boolean;
  tokenData?: TokenData;
  isAutomation?: boolean;
  service?: string;
} & (
  | {
      isAutomation?: true;
      service: string;
    }
  | { isAutomation?: false; service?: string }
);
